import { PERMISSION_KEYS, ROLES } from '../constants';
import { RULE_TYPES } from './rules.config';
import { removeKeyFromTargetList } from '../utils/ruleTargetHelpers';

export const RULE_OVERRIDES_BY_ROLE = {
  [ROLES.SUPERVISOR]: {
    [RULE_TYPES.LOCK_WHEN_CHECKED]: {
      remove: [
        { trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY, target: PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY },
        { trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY, target: PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY },
        { trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY, target: PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY },
        { trigger: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY, target: PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY },
      ],
    },
  },
};

export function applyRoleRuleOverrides(rules, role) {
  const overridesForRole = RULE_OVERRIDES_BY_ROLE[role];
  if (!overridesForRole) return rules;

  const resolved = { ...rules };

  Object.entries(overridesForRole).forEach(([ruleType, override]) => {
    const ruleConfig = resolved[ruleType];
    if (!ruleConfig?.targets || !override.remove) return;

    const targets = { ...ruleConfig.targets };
    override.remove.forEach(({ trigger, target }) => {
      if (!targets[trigger]) return;
      const filteredList = removeKeyFromTargetList(targets[trigger], target);
      if (filteredList.length === 0) {
        delete targets[trigger];
      } else {
        targets[trigger] = filteredList;
      }
    });

    resolved[ruleType] = { ...ruleConfig, targets };
  });

  return resolved;
}
